import Base from './base';
import GolfId from './golfid';

export default {
  base: Base,
  default: GolfId
}
